module.exports = __webpack_public_path__ + "static/media/main_img.f83c50f5.png";